<template lang="pug">
.v-compare-action.compare-action(:class="{'active': compareCountByItem, 'disabled': disabled, 'compare-action--full': full}")
	.compare-action__widget
		.compare-action__cell-main
			button.compare-action__btn(
					type="button"
					:disabled="disabled"
					@click="toggleFavoriteCount"
					aria-label="Добавить в избранное")
				svg.svg-icon.compare-action__btn-icon
					use(xlink:href="#svg-icon-compare")
				template(v-if="full")
					.compare-action__text.compare-action__text--shown Cравнить
					.compare-action__text.compare-action__text--hidden В сравнении
</template>

<script>
export default {
	props: {
		id: {
			type: [String, Number],
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		},

		full: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			localCount: 0
		};
	},

	computed: {
		compareCountByItem() {
			return this.$store.getters['compare/compareCountByItem'](this.id);
		}
	},

	created() {
		this.localCount = this.compareCountByItem;
	},

	methods: {
		toggleFavoriteCount() {
			if (this.compareCountByItem) {
				this.$store.dispatch('compare/remove', {
					id: this.id
				});
			} else {
				this.$store.dispatch('compare/add', {
					id: this.id,
					count: this.localCount
				});
			}
		}
	}
};
</script>